export default __webpack_public_path__ + "static/media/KLGR_Logo_White_png.e416747f.png";